
import { useState } from 'react';

export const HeroSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleConsultationSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    
    setIsSubmitting(true);
    setSubmitMessage('');
    
    try {
      const formData = new FormData();
      formData.append('email', email);
      
      const response = await fetch('https://readdy.ai/api/form/consultation-request', {
        method: 'POST',
        body: new URLSearchParams(formData as any),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      
      if (response.ok) {
        setSubmitMessage('Thank you! We\'ll contact you soon to schedule your consultation.');
        setEmail('');
      } else {
        setSubmitMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/af0c8f95c1124790563fb9c66486c00c.jpg')`
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-4xl text-left text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Building Tomorrow's
            <span className="block text-teal-400">Communities Today</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl">
            Avalar Realty Holdings development company creating exceptional residential and commercial properties. 
            From groundbreaking to grand opening, we deliver luxury developments that exceed expectations.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Schedule Development Consultation
            </button>
            <button 
              onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Learn More About Us
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 max-w-md">
            <h3 className="text-lg font-semibold mb-4">Get Development Updates</h3>
            <form onSubmit={handleConsultationSubmit} data-readdy-form id="hero-consultation-form">
              <div className="flex">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-3 bg-white/20 text-white placeholder-gray-300 border border-white/30 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                  required
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-6 py-3 bg-teal-600 text-white rounded-r-lg hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-400 disabled:opacity-50 cursor-pointer whitespace-nowrap"
                >
                  {isSubmitting ? 'Sending...' : 'Notify Me'}
                </button>
              </div>
              {submitMessage && (
                <p className={`mt-2 text-sm ${submitMessage.includes('Thank you') ? 'text-green-300' : 'text-red-300'}`}>
                  {submitMessage}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
